import http from "@/tools/http";

export default {
  upload(file) {
    const fd = new FormData();
    fd.append("upload", file);

    return http.post("/upload", fd, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${fd._boundary}`
      }
    });
  }
};
